import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// Public klasöründeki logo'yu kullan (cache-busting için)
const menomV2Logo = '/menomV2Logo.png';

/**
 * Route'a göre sayfa başlığını ve favicon'u dinamik olarak günceller
 */
export default function TitleManager() {
  const location = useLocation();

  useEffect(() => {
    // Favicon linkini bul veya oluştur
    let link = document.querySelector("link[rel*='icon']") || 
               document.querySelector("link[rel='shortcut icon']");
    
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      document.getElementsByTagName('head')[0].appendChild(link);
    } else {
      // Mevcut link'i güncelle
      if (!link.type) {
        link.type = 'image/png';
      }
    }

    // Route'a göre title ve favicon'u ayarla
    if (location.pathname === '/') {
      // Landing page
      document.title = 'Menom - Restoran Sipariş ve Yönetim Sistemi';
      // Cache'i bypass etmek için timestamp ekle
      link.href = `${menomV2Logo}?v=${Date.now()}`;
    } else if (location.pathname === '/business') {
      // Business landing page
      document.title = 'Menom Business - İşletmeler İçin Dijital Çözümler';
      link.href = `${menomV2Logo}?v=${Date.now()}`;
    } else if (location.pathname.startsWith('/download')) {
      // Download page
      document.title = 'Menom - Restoran Sipariş ve Yönetim Sistemi';
      link.href = `${menomV2Logo}?v=${Date.now()}`;
    } else if (location.pathname.startsWith('/admin')) {
      // Admin panel
      document.title = 'MenomSoft Business Panel';
      link.href = `/businessLogoNew.png?v=${Date.now()}`;
    } else if (location.pathname.startsWith('/auth')) {
      // Auth sayfaları
      document.title = 'MenomSoft Business';
      link.href = `/businessLogoNew.png?v=${Date.now()}`;
    } else {
      // Diğer sayfalar
      document.title = 'MenomSoft Business Panel';
      link.href = `/businessLogoNew.png?v=${Date.now()}`;
    }
    
    // Favicon'u zorla yeniden yükle
    const newLink = link.cloneNode(true);
    link.parentNode?.replaceChild(newLink, link);
  }, [location.pathname]);

  return null;
}

